import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import BookingOverlay from './BookingOverlay';

const MenuOverlay = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [shouldRender, setShouldRender] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      const timer = setTimeout(() => setIsVisible(true), 50);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
      const timer = setTimeout(() => setShouldRender(false), 800);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!shouldRender) return null;

  const overlayContent = (
    <div
      className={`transition-opacity duration-700 ease-in-out ${isVisible ? 'opacity-100' : 'opacity-0'
        }`}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#000000',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Montserrat, sans-serif',
        margin: 0,
        padding: 0
      }}
    >
      {/* Top Center Title */}
      <div style={{ position: 'absolute', top: isMobile ? '24px' : '48px', left: 0, right: 0, display: 'flex', justifyContent: 'center' }}>
        <h2
          className="tracking-extra-wide uppercase"
          style={{ color: '#ffffff', fontFamily: 'Montserrat, sans-serif', fontSize: isMobile ? '14px' : '18px', textShadow: 'none', fontWeight: 300 }}
        >
          Joshua Gavin
        </h2>
      </div>

      {/* Close X Button */}
      <button
        onClick={onClose}
        className="hover:opacity-70 transition-opacity duration-300"
        style={{
          position: 'absolute',
          top: isMobile ? '20px' : '48px',
          right: isMobile ? '20px' : '48px',
          background: 'none',
          border: 'none',
          color: '#ffffff',
          fontSize: isMobile ? '28px' : '32px',
          cursor: 'pointer',
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 300,
          padding: 0,
          lineHeight: 1
        }}
        aria-label="Close menu"
      >
        ×
      </button>

      {/* Center Navigation Links */}
      <nav style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', gap: isMobile ? '20px' : '32px', marginBottom: isMobile ? '32px' : '64px' }}>
        <button
          className="tracking-wider transition-all duration-300"
          onClick={() => { navigate('/'); onClose(); }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#36454F'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
          style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontFamily: 'Montserrat, sans-serif', color: '#ffffff', fontWeight: 700, fontSize: isMobile ? '36px' : '68px', padding: isMobile ? '8px 0' : 0, margin: 0, lineHeight: 1 }}
        >
          HOME
        </button>
        <button
          className="tracking-wider transition-all duration-300"
          onClick={() => { navigate('/work'); onClose(); }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#36454F'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
          style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontFamily: 'Montserrat, sans-serif', color: '#ffffff', fontWeight: 700, fontSize: isMobile ? '36px' : '68px', padding: isMobile ? '8px 0' : 0, margin: 0, lineHeight: 1 }}
        >
          LIVE EVENTS
        </button>
        <button
          className="tracking-wider transition-all duration-300"
          onClick={() => setIsBookingOpen(true)}
          onMouseEnter={(e) => e.currentTarget.style.color = '#36454F'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
          style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontFamily: 'Montserrat, sans-serif', color: '#ffffff', fontWeight: 700, fontSize: isMobile ? '36px' : '68px', padding: isMobile ? '8px 0' : 0, margin: 0, lineHeight: 1 }}
        >
          BOOKINGS
        </button>
      </nav>

      {/* Contact Email */}
      <div style={{ marginBottom: '32px' }}>
        <a
          href="mailto:contact@joshuagavin.com"
          className="text-lg md:text-xl hover:opacity-70 transition-opacity duration-300"
          style={{ fontFamily: 'Montserrat, sans-serif', textDecoration: 'none', color: '#ffffff' }}
        >
          contact@joshuagavin.com
        </a>
      </div>

      {/* Social Media Icons */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
        {/* Instagram Icon */}
        <a
          href="https://www.instagram.com/joshuagav_/"
          target="_blank"
          rel="noopener noreferrer"
          className="transition-all duration-300 rounded-full"
          aria-label="Instagram"
          onMouseEnter={(e) => e.currentTarget.style.color = '#36454F'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px', color: '#ffffff' }}
        >
          <svg
            width="32"
            height="32"
            fill="currentColor"
            viewBox="0 0 24 24"
            style={{ display: 'block' }}
          >
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
          </svg>
        </a>

        {/* YouTube Icon */}
        <a
          href="https://www.youtube.com/@joshuagavinn"
          target="_blank"
          rel="noopener noreferrer"
          className="transition-all duration-300 rounded-full"
          aria-label="YouTube"
          onMouseEnter={(e) => e.currentTarget.style.color = '#36454F'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px', color: '#ffffff' }}
        >
          <svg
            width="32"
            height="32"
            fill="currentColor"
            viewBox="0 0 24 24"
            style={{ display: 'block' }}
          >
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
          </svg>
        </a>
      </div>
    </div>
  );

  return (
    <>
      {ReactDOM.createPortal(overlayContent, document.body)}
      <BookingOverlay isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} />
    </>
  );
};

export default MenuOverlay;
